// import React, { useEffect } from "react";
// import { BrowserRouter, Routes, Route, useLocation, useParams } from "react-router-dom";
// import "./App.css";

// import Pararesults from "./report";
// import Page from "./report2";
// import Btn from "./btn";
// import { useState } from "react";





// function ScrollToTop() {
//   const { pathname } = useLocation();          
//   useEffect(() => {
//     window.scrollTo(0, 0);
//   }, [pathname]);

//   return null;
// }

// function App() {
//   const {id} = useParams()
//   const YourGutMap = {
//     "logo":"/paralogo.jpg",
//     "primaryColor":"#724e9e",
//         "secondaryColor":"#4180b8",
// }

//     const [reportStyle,setReportStyle] = useState(YourGutMap)

//     const [primaryColor,setPrimaryColor] = useState("#724e9e");
//     const [mainColor,setMainColor] = useState("#724e9e");
//     const [secondaryColor,setSecondaryColor] = useState("#4180b8");
//   //   const [logo,setLogo] = useState("/logo.jpg");
//     const [logo,setLogo] = useState("/blank.png");
//     const [styleName,setStyleName] = useState("YourGutMap");
//     const [header,setHeader] = useState()
//     const [footer,setFooter] = useState()
//     const [isUpdated,setIsUpdated] = useState(false)



// const lightenColor = (color, percent) => {
//     const num = parseInt(color.replace("#", ""), 16);
//     const amt = Math.round(2.55 * percent);
//     const R = (num >> 16) + amt;
//     const G = ((num >> 8) & 0x00ff) + amt;
//     const B = (num & 0x0000ff) + amt;
  
//     return (
//       "#" +
//       (
//         0x1000000 +
//         (R < 255 ? (R < 1 ? 0 : R) : 255) * 0x10000 +
//         (G < 255 ? (G < 1 ? 0 : G) : 255) * 0x100 +
//         (B < 255 ? (B < 1 ? 0 : B) : 255)
//       )
//         .toString(16)
//         .slice(1)
//     );
//   };
  

// useEffect(() => {
//     const lightColor = lightenColor(primaryColor, 40); // 40% lighter

//   const updatedMap = {
//     header: header || "/blank.png",
//     footer: footer || "/blank.png",
//     logo: logo,
//     primaryColor: lightColor,
//     mainColor:primaryColor,
//     secondaryColor: secondaryColor,
//     fontColor: primaryColor,
//     header:header,
//     footer:footer,
//   };

//   setReportStyle(updatedMap);
// }, [styleName, logo, primaryColor, secondaryColor]);




// useEffect(() => {
//     const fetchReportStyle = async () => {
//       try {
//         // const response = await fetch("http://localhost:1337/getReportStyleByKit", {
//         const response = await fetch("https://yourgutmap-food-sensitivity-423a2af84621.herokuapp.com/getReportStyleByKit", {
//         // const response = await fetch("http://192.168.100.48:1338/getReportStyleByKit", {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ kitId: id }), // Send the kit ID
//         });

//         const result = await response.json();

//         if (response.ok && result.style) {
//           // Update colors and logo if style data exists
//           setPrimaryColor(result.style.primaryColor);
//           setSecondaryColor(result.style.secondaryColor);
//           setLogo(result.style.imageBase64);
//           setStyleName(result.style.styleName);
//           setHeader(result.style.header);
//           setFooter(result.style.footer);
//           setIsUpdated(true)
//           // setStyleUpdated(true);
//           // console.log(primaryColor)
//         //   alert(reportStyle.styleName)
//         }
//       } catch (error) {
//         console.error("Error fetching report style:", error);
//       }
//     };

//     fetchReportStyle();
//   }, [id]); // Runs when the component mounts




//   return (
//     <div className="App">
//       <BrowserRouter>
//         <ScrollToTop />

//         <Routes>
//           <Route path="/:id/parasitology" element={<Pararesults myReportStyle={reportStyle}/>} />
//           <Route path="/:id/candida" element={<Page myReportStyle={reportStyle} />} />
//           <Route path="/:id" element={<Btn myReportStyle={reportStyle} />} />
//           {/* <Route path="/:id" element={<Page />} /> */}
//         </Routes>
//       </BrowserRouter>
//     </div>
//   );
// }

// export default App;





import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
// import ScrollToTop from "./ScrollToTop";
import ReportWrapper from "./reportwrapper";

function ScrollToTop() {
  const { pathname } = useLocation();          
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/:id/*" element={<ReportWrapper />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
